
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30571',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30571",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54992",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8175",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11622",
  "I18n": "static-7.1643",
  "quartz": "static-1.7230",
  "quartz-config": "static-1.1008",
  "quartz-core": "static-1.6449",
  "react-dlb": "static-1.82",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.7",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.836",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54979",
  "feedback-utils": "static-1.54983",
  "forms-embed-utils-lib": "static-1.4616",
  "forms-utils-lib": "static-1.12873",
  "foundations-assets": "static-1.5027",
  "foundations-components": "static-1.8239",
  "foundations-theming": "static-1.4590",
  "hub-http": "static-1.6374",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11929",
  "icons": "static-2.659",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4029",
  "raven": "static-3.5925",
  "react": "static-7.188",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16846",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5453",
  "react-virtualized": "static-2.101",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.490",
  "tinymce-plugins": "static-1.57887",
  "transmute": "static-2.85",
  "ui-images": "static-2.1195",
  "UIComponents": "static-3.8568",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3513",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3507",
  "quartz-webpack": "static-1.3454",
  "foundations-theming-specialty": "static-1.2306",
  "property-description-translator": "static-1.3993",
  "HeadJS": "static-2.775",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3286",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4478",
  "jasmine-runner": "static-1.6610",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4763",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.905",
  "quartz-head": "static-1.895",
  "quartz-i18n": "static-1.905",
  "quartz-routing": "static-1.660",
  "quartz-test": "static-1.905",
  "quartz-tracking": "static-1.609",
  "trellis-components": "static-1.2270",
  "ui-fonts": "static-1.884",
  "usage-tracker-container": "static-1.7495",
  "usage-tracker-core": "static-1.7355",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7401",
  "reference-resolvers": "static-1.8329",
  "sanitize-text": "static-1.8299",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10516",
  "sanitize": "static-1.4631",
  "outpost": "static-1.4321",
  "rpc-client-utils": "static-1.4814",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4508",
  "floating-ui": "static-1.59",
  "hs-story-utils": "static-1.9576",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.41",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2251",
  "bend-plugin-foundations-theming": "static-1.3073",
  "foundations-theming-base": "static-1.3575",
  "stylex": "static-1.36",
  "hs-locale-management": "static-1.194",
  "csstype": "static-1.50",
  "web-vitals": "static-1.8",
  "ai-components-ui-library": "static-1.9335",
  "atom": "static-1.5228",
  "codemirror": "static-5.97",
  "content-assistance-lib": "static-1.7996",
  "ContentUtils": "static-1.68806",
  "data-token-picker": "static-1.16682",
  "file-manager-components": "static-1.24074",
  "FileManagerCore": "static-1.39573",
  "FileManagerLib": "static-1.39714",
  "frontend-preferences-client": "static-1.8080",
  "hub-http-contrib": "static-1.3197",
  "interframe": "static-3.4911",
  "layout-dnd-components": "static-1.12746",
  "layout-dnd-utils": "static-1.11721",
  "property-translator": "static-1.5549",
  "react-codemirror": "static-1.10781",
  "react-colorpicker": "static-2.10361",
  "reference-resolvers-lite": "static-1.8250",
  "rich-text-lib": "static-1.20101",
  "tinymce-data": "static-1.40858",
  "tinymce-themes": "static-1.56743",
  "ui-addon-emoji-picker": "static-1.10037",
  "ui-addon-sales-email": "static-1.5364",
  "ui-brand-identity-lib": "static-1.15843",
  "bender-build-tools": "static-1.3301",
  "hub-http-shared-msw-handlers": "static-1.10338",
  "hubspotter-http-shared-msw-handlers": "static-1.10336",
  "usage-tracker-session-replay": "static-1.5191",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1101",
  "tanstack-virtual": "static-1.32",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.224",
  "chirp-fetch": "static-1.2041",
  "chatspot-core": "static-1.22053",
  "copilot-toolkit": "static-1.11523",
  "customer-data-objects-ui-components": "static-1.13183",
  "data-fetching-client": "static-1.9813",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4913",
  "ui-addon-video-player": "static-1.8858",
  "ui-coaching-tips": "static-1.28980",
  "usage-tracker": "static-1.7505",
  "cms-field-types": "static-1.4968",
  "content-icons-ui": "static-1.2272",
  "integrations-lib": "static-1.16636",
  "customer-data-objects": "static-1.7832",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1253",
  "apollo-link-hub-http": "static-2.4804",
  "apollo-stack-hubspot": "static-3.88",
  "graphql": "static-1.84",
  "immer": "static-1.33",
  "immerable": "static-1.4304",
  "ui-addon-iframeable": "static-1.9225",
  "video-components-external": "static-1.11783",
  "video-data-lib": "static-1.35441",
  "audio-components": "static-1.6153",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29586",
  "FileManagerImages": "static-1.37225",
  "foundations-components-legacy": "static-1.1264",
  "html-to-image": "static-1.56",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.528",
  "ui-universal-auth": "static-1.9162",
  "urlinator": "static-1.4687",
  "video-components": "static-1.13785",
  "video-embed": "static-1.36275",
  "ts-schema": "static-1.4194",
  "ContentData": "static-1.68881",
  "layout-data-lib": "static-1.10046",
  "react-dnd-compat": "static-1.4767",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1697",
  "external-options-client-types": "static-1.4239",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7049",
  "hs-promise-utils": "static-1.5747",
  "inbound-db-properties-service-client": "static-1.3959",
  "NamespacedHubStyle": "static-2.9166",
  "growth-onboarding-confetti": "static-1.3220",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11302",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5653",
  "magpie-types": "static-1.5113",
  "simple-logging-lib": "static-1.3201",
  "avatar-components": "static-1.2652",
  "customer-data-ui-utilities": "static-1.9976",
  "growth-onboarding-feedback-components": "static-1.6732",
  "flux-actions": "static-1.350",
  "hubspot-apollo-client": "static-1.5032",
  "integrations-error-boundary-lib": "static-1.14051",
  "integrations-tracking-lib": "static-1.5760",
  "laboratory-lib": "static-3.7306",
  "native-integrations-shared-strings": "static-1.7933",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10411",
  "unified-auth": "static-1.676",
  "breeze-engine-core": "static-1.531",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "navigation-messaging": "static-1.7719",
  "content-media-composition-data-lib": "static-1.12804",
  "content-media-compositions": "static-2.16811",
  "idb-keyval": "static-1.46",
  "media-bridge-lib": "static-1.19198",
  "unified-auth-core-lib": "static-1.958",
  "social-insights-client-types": "static-1.22463",
  "advanced-menus-core": "static-1.15386",
  "advanced-menus-lib": "static-1.12288",
  "ExportDialog": "static-6.10532",
  "ui-memberships-settings-lib": "static-1.34456",
  "conditional-properties-service-client": "static-1.3910",
  "crm-pipelines-api-client-types": "static-1.4250",
  "fdsr-migration-layer": "static-1.168",
  "framework-builder-read-service-client": "static-1.4118",
  "framework-data-schema-quick-fetch": "static-1.6954",
  "inbound-db-meta-service-client": "static-1.3701",
  "multi-currency-client-types": "static-1.3805",
  "persist-promise": "static-1.3854",
  "foundations-components-test-utils": "static-1.5722",
  "reactive-lib": "static-1.879",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.491",
  "universal-page-editor-lib": "static-1.3165",
  "adobe-sign-auth-lib": "static-1.117",
  "ads-unified-auth-lib": "static-1.596",
  "google-sheets-integration-lib": "static-1.684",
  "microsoft-drive-integration-lib": "static-1.850",
  "surveymonkey-integration-lib": "static-1.135",
  "slack-ui-library": "static-1.10551",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3883",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15385",
  "simple-menus-lib": "static-1.16902",
  "crm-record-cards-service-types": "static-1.3698",
  "location-customization-utils-lib": "static-1.9698",
  "react-flip-move": "static-1.73"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30571",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54992",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8175",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11622",
  "I18n": "/I18n/static-7.1643",
  "quartz": "/quartz/static-1.7230",
  "quartz-config": "/quartz-config/static-1.1008",
  "quartz-core": "/quartz-core/static-1.6449",
  "react-dlb": "/react-dlb/static-1.82",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.7",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.836",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54979",
  "feedback-utils": "/feedback-utils/static-1.54983",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4616",
  "forms-utils-lib": "/forms-utils-lib/static-1.12873",
  "foundations-assets": "/foundations-assets/static-1.5027",
  "foundations-components": "/foundations-components/static-1.8239",
  "foundations-theming": "/foundations-theming/static-1.4590",
  "hub-http": "/hub-http/static-1.6374",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11929",
  "icons": "/icons/static-2.659",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4029",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.188",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16846",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5453",
  "react-virtualized": "/react-virtualized/static-2.101",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tinymce-plugins": "/tinymce-plugins/static-1.57887",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1195",
  "UIComponents": "/UIComponents/static-3.8568",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3513",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3507",
  "quartz-webpack": "/quartz-webpack/static-1.3454",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2306",
  "property-description-translator": "/property-description-translator/static-1.3993",
  "HeadJS": "/HeadJS/static-2.775",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3286",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4478",
  "jasmine-runner": "/jasmine-runner/static-1.6610",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4763",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.905",
  "quartz-head": "/quartz-head/static-1.895",
  "quartz-i18n": "/quartz-i18n/static-1.905",
  "quartz-routing": "/quartz-routing/static-1.660",
  "quartz-test": "/quartz-test/static-1.905",
  "quartz-tracking": "/quartz-tracking/static-1.609",
  "trellis-components": "/trellis-components/static-1.2270",
  "ui-fonts": "/ui-fonts/static-1.884",
  "usage-tracker-container": "/usage-tracker-container/static-1.7495",
  "usage-tracker-core": "/usage-tracker-core/static-1.7355",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7401",
  "reference-resolvers": "/reference-resolvers/static-1.8329",
  "sanitize-text": "/sanitize-text/static-1.8299",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10516",
  "sanitize": "/sanitize/static-1.4631",
  "outpost": "/outpost/static-1.4321",
  "rpc-client-utils": "/rpc-client-utils/static-1.4814",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4508",
  "floating-ui": "/floating-ui/static-1.59",
  "hs-story-utils": "/hs-story-utils/static-1.9576",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2251",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3073",
  "foundations-theming-base": "/foundations-theming-base/static-1.3575",
  "stylex": "/stylex/static-1.36",
  "hs-locale-management": "/hs-locale-management/static-1.194",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.8",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9335",
  "atom": "/atom/static-1.5228",
  "codemirror": "/codemirror/static-5.97",
  "content-assistance-lib": "/content-assistance-lib/static-1.7996",
  "ContentUtils": "/ContentUtils/static-1.68806",
  "data-token-picker": "/data-token-picker/static-1.16682",
  "file-manager-components": "/file-manager-components/static-1.24074",
  "FileManagerCore": "/FileManagerCore/static-1.39573",
  "FileManagerLib": "/FileManagerLib/static-1.39714",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8080",
  "hub-http-contrib": "/hub-http-contrib/static-1.3197",
  "interframe": "/interframe/static-3.4911",
  "layout-dnd-components": "/layout-dnd-components/static-1.12746",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11721",
  "property-translator": "/property-translator/static-1.5549",
  "react-codemirror": "/react-codemirror/static-1.10781",
  "react-colorpicker": "/react-colorpicker/static-2.10361",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8250",
  "rich-text-lib": "/rich-text-lib/static-1.20101",
  "tinymce-data": "/tinymce-data/static-1.40858",
  "tinymce-themes": "/tinymce-themes/static-1.56743",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10037",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5364",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15843",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10338",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10336",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5191",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1101",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.224",
  "chirp-fetch": "/chirp-fetch/static-1.2041",
  "chatspot-core": "/chatspot-core/static-1.22053",
  "copilot-toolkit": "/copilot-toolkit/static-1.11523",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13183",
  "data-fetching-client": "/data-fetching-client/static-1.9813",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4913",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8858",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28980",
  "usage-tracker": "/usage-tracker/static-1.7505",
  "cms-field-types": "/cms-field-types/static-1.4968",
  "content-icons-ui": "/content-icons-ui/static-1.2272",
  "integrations-lib": "/integrations-lib/static-1.16636",
  "customer-data-objects": "/customer-data-objects/static-1.7832",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1253",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4804",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "graphql": "/graphql/static-1.84",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4304",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9225",
  "video-components-external": "/video-components-external/static-1.11783",
  "video-data-lib": "/video-data-lib/static-1.35441",
  "audio-components": "/audio-components/static-1.6153",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29586",
  "FileManagerImages": "/FileManagerImages/static-1.37225",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1264",
  "html-to-image": "/html-to-image/static-1.56",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.528",
  "ui-universal-auth": "/ui-universal-auth/static-1.9162",
  "urlinator": "/urlinator/static-1.4687",
  "video-components": "/video-components/static-1.13785",
  "video-embed": "/video-embed/static-1.36275",
  "ts-schema": "/ts-schema/static-1.4194",
  "ContentData": "/ContentData/static-1.68881",
  "layout-data-lib": "/layout-data-lib/static-1.10046",
  "react-dnd-compat": "/react-dnd-compat/static-1.4767",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1697",
  "external-options-client-types": "/external-options-client-types/static-1.4239",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7049",
  "hs-promise-utils": "/hs-promise-utils/static-1.5747",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3959",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9166",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3220",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11302",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5653",
  "magpie-types": "/magpie-types/static-1.5113",
  "simple-logging-lib": "/simple-logging-lib/static-1.3201",
  "avatar-components": "/avatar-components/static-1.2652",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9976",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6732",
  "flux-actions": "/flux-actions/static-1.350",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5032",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14051",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5760",
  "laboratory-lib": "/laboratory-lib/static-3.7306",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7933",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10411",
  "unified-auth": "/unified-auth/static-1.676",
  "breeze-engine-core": "/breeze-engine-core/static-1.531",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "navigation-messaging": "/navigation-messaging/static-1.7719",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12804",
  "content-media-compositions": "/content-media-compositions/static-2.16811",
  "idb-keyval": "/idb-keyval/static-1.46",
  "media-bridge-lib": "/media-bridge-lib/static-1.19198",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.958",
  "social-insights-client-types": "/social-insights-client-types/static-1.22463",
  "advanced-menus-core": "/advanced-menus-core/static-1.15386",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12288",
  "ExportDialog": "/ExportDialog/static-6.10532",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34456",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3910",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4250",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.168",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4118",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6954",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3701",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3805",
  "persist-promise": "/persist-promise/static-1.3854",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5722",
  "reactive-lib": "/reactive-lib/static-1.879",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.491",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3165",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.117",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.596",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.684",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.850",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.135",
  "slack-ui-library": "/slack-ui-library/static-1.10551",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3883",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15385",
  "simple-menus-lib": "/simple-menus-lib/static-1.16902",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3698",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9698",
  "react-flip-move": "/react-flip-move/static-1.73"
}
};
